// Keep these tokens visually aligned with zep-crm admin-web
// `src/crm/components/PopupCard.tsx`. The admin preview is the source of truth.

export const FONT_FAMILY =
  '"Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const White = '#FFFFFF';
export const Black = '#1C1B1F';
export const Gray50 = '#F5F6F9';
export const Gray700 = '#5D5E69';
export const Gray900 = '#27262E';
export const Red400 = '#FF737B';
export const Violet50 = '#F3F2FF';
export const Violet500 = '#6758FF';
export const Violet600 = '#5748F2';
export const BORDER_OUTLINED_NEUTRAL = 'rgba(28, 27, 31, 0.12)';
export const COLOR_BORDER_ASSISTIVE = 'rgba(28, 27, 31, 0.04)';

export const SHADOW_NOTICE =
  '0px 8px 20px 0px rgba(28, 27, 31, 0.12), 0px 0px 16px 0px rgba(28, 27, 31, 0.08)';
export const SHADOW_CLOSE =
  '0px 1px 4px 0px rgba(28, 27, 31, 0.12), 0px 0px 6px 0px rgba(28, 27, 31, 0.04)';
export const SHADOW_DIALOG =
  '0px 20px 32px 0px rgba(28, 27, 31, 0.12), 0px 0px 20px 0px rgba(28, 27, 31, 0.08)';

export const RADIUS_MD = '16px';
export const RADIUS_SM = '8px';
export const RADIUS_LG = '24px';
export const SP = {
  '3xs': '4px',
  '2xs': '6px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
} as const;
